<template>
  <div class="logContainer">
    <div class="tabs">
      <el-tabs v-model="activeName" class="header_tab" @tab-click="handleClick">
        <el-tab-pane label="系统日志" name="系统" />
        <el-tab-pane label="项目日志" name="项目" />
      </el-tabs>
    </div>
    <div class="bottom">
      <template v-if="activeName === '系统'">
        <SystemLog />
      </template>
      <template v-if="activeName === '项目'">
        <ProjectLog />
      </template>
    </div>
  </div>
</template>

<script>
import SystemLog from "./operLog";
import ProjectLog from "./projectLog";

export default {
  components: {
    SystemLog,
    ProjectLog
  },
  data() {
    return {
      activeName: "系统"
    };
  },

  methods: {
    async handleClick() {
      if (this.activeName === "设计") {
        this.type = 1;
      } else {
        this.type = 2;
      }
    }
  }
};
</script>
<style></style>
<style lang="scss" scoped>
.logContainer {
  position: relative;
  height: 100%;
  // width: 100%;
  padding: 0 var(--big-space);
  background-color: #fff;
  display: flex;
  flex-direction: column;
  .tabs {
    padding-top: var(--small-space);
  }
  .bottom {
    height: 1px;
    flex: 1 0 1px;
  }
  .header_tab /deep/ .el-tabs__nav-wrap::after {
    height: 1px;
    background-color: #ebefff;
  }
}
</style>
